
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Properties', path: '/properties' },
    { name: 'For Landlords', path: '/landlords' },
    { name: 'FAQ', path: '/faq' },
    { name: 'About', path: '/about' },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50 transition-all duration-300">
      <nav className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3 group">
            <div 
              className="w-14 h-14 bg-cover bg-center rounded-2xl shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-105 flex items-center justify-center relative overflow-hidden"
              style={{
                backgroundImage: `url('https://public.readdy.ai/ai/img_res/6be61980acb5527e40900c8ac5917ab6.jpg')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500/95 to-blue-600/95"></div>
              <div className="relative text-center">
                <div className="text-white font-bold text-2xl tracking-wider leading-none">ARM</div>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-900 font-bold text-base leading-tight">Ali Residential Management LLC</div>
              <div className="text-gray-600 text-xs font-medium leading-tight mt-0.5">Your Home Away</div>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-base font-medium transition-all duration-300 whitespace-nowrap cursor-pointer relative group ${
                  location.pathname === item.path
                    ? 'text-teal-600'
                    : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                {item.name}
                <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-teal-600 transform origin-left transition-transform duration-300 ${
                  location.pathname === item.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                }`}></span>
              </Link>
            ))}
            <a
              href="sms:732-213-2063"
              className="px-6 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-semibold rounded-lg hover:from-teal-600 hover:to-teal-700 transition-all duration-300 transform hover:scale-105 shadow-md whitespace-nowrap cursor-pointer flex items-center"
            >
              <i className="ri-message-3-line mr-2"></i>
              732-213-2063
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer hover:bg-gray-100 rounded-lg transition-all duration-300"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700 transition-transform duration-300 ${isMenuOpen ? 'rotate-90' : ''}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100 animate-fade-in">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block py-3 px-4 text-base font-medium cursor-pointer rounded-lg transition-all duration-300 ${
                  location.pathname === item.path
                    ? 'text-teal-600 bg-teal-50'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-teal-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href="sms:732-213-2063"
              className="block mt-4 mx-4 px-6 py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white font-semibold rounded-lg text-center cursor-pointer"
            >
              <i className="ri-message-3-line mr-2"></i>
              Text: 732-213-2063
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
